import { render, staticRenderFns } from "./Trademark-Sharing.vue?vue&type=template&id=112dded4&scoped=true&"
import script from "./Trademark-Sharing.vue?vue&type=script&lang=js&"
export * from "./Trademark-Sharing.vue?vue&type=script&lang=js&"
import style0 from "./Trademark-Sharing.vue?vue&type=style&index=0&id=112dded4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112dded4",
  null
  
)

export default component.exports